import React from 'react'
import { Typography, Chip, Grid } from '@the-platform-group/component-library'
import { getJobTitleAndOrgName } from 'pages/MergeProfiles/utils'

const JobLabel = ({ job, jobPreview }) => (
  <Grid container>
    <Grid item container alignItems="center" spacing={1}>
      <Grid item>
        <Typography variant="body2">{getJobTitleAndOrgName(job)}</Typography>
      </Grid>
      {job.isPrimary && (
        <Grid item>
          <Chip label="Primary" variant="outlined" color="primary" size="x-small" />
        </Grid>
      )}
    </Grid>
    {jobPreview && (
      <Grid item xs={12}>
        <Typography variant="caption" color="primary">
          Affiliations: {calculateJobAffiliations(jobPreview)}
        </Typography>
      </Grid>
    )}
  </Grid>
)

const calculateJobAffiliations = jobPreview => {
  const { activityCount = 0, customerFavoritePeopleCount = 0, surveyResponseCount = 0 } = jobPreview

  return activityCount + customerFavoritePeopleCount + surveyResponseCount
}

export default JobLabel
